import { vi } from 'date-fns/locale';
import { format } from 'date-fns';

export const formatDateRange = (searchParams: BanHangSearchParams) => {
  if (!searchParams?.ngay_tu && !searchParams?.ngay_den) {
    return '';
  }

  const fromDate = searchParams?.ngay_tu;
  const toDate = searchParams?.ngay_den;

  if (fromDate && toDate) {
    try {
      const formattedFromDate = format(new Date(fromDate), 'dd/MM/yyyy', { locale: vi });
      const formattedToDate = format(new Date(toDate), 'dd/MM/yyyy', { locale: vi });
      return ` Từ ngày ${formattedFromDate} đến ngày ${formattedToDate}`;
    } catch (error) {
      console.warn('Error formatting dates:', error);
      return ` Từ ngày ${fromDate} đến ngày ${toDate}`;
    }
  } else if (fromDate) {
    try {
      const formattedFromDate = format(new Date(fromDate), 'dd/MM/yyyy', { locale: vi });
      return ` Từ ngày ${formattedFromDate}`;
    } catch (error) {
      return ` Từ ngày ${fromDate}`;
    }
  } else if (toDate) {
    try {
      const formattedToDate = format(new Date(toDate), 'dd/MM/yyyy', { locale: vi });
      return ` đến ngày ${formattedToDate}`;
    } catch (error) {
      return ` đến ngày ${toDate}`;
    }
  }

  return '';
};
